// extracted by mini-css-extract-plugin
module.exports = {"resend-link":"doiSuccessResendLink___resend-link___272s6"};